import React from 'react';

function LowUsageIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_21_1925)">
        <path
          d="M12.5 19C12.2 19 12 18.9 11.8 18.7L6.3 13.2C5.9 12.8 5.9 12.2 6.3 11.8C6.7 11.4 7.3 11.4 7.7 11.8L12.5 16.6L17.3 11.8C17.7 11.4 18.3 11.4 18.7 11.8C19.1 12.2 19.1 12.8 18.7 13.2L13.2 18.7C13 18.9 12.8 19 12.5 19ZM13.2 12.2L18.7 6.7C19.1 6.3 19.1 5.7 18.7 5.3C18.3 4.9 17.7 4.9 17.3 5.3L12.5 10.1L7.7 5.3C7.3 4.9 6.7 4.9 6.3 5.3C5.9 5.7 5.9 6.3 6.3 6.7L11.8 12.2C12 12.4 12.2 12.5 12.5 12.5C12.8 12.5 13 12.4 13.2 12.2Z"
          fill="#369FFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_21_1925">
          <rect
            width="13"
            height="14"
            fill="white"
            transform="translate(6 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default LowUsageIcon;
